module.exports = __webpack_public_path__ + "img/8-3.1fc845eb.jpg";